import React from "react";
import { useNavigate } from "react-router-dom";
import "./product-form.scss";

const ProductFormPage = ({ mode = "create" }) => {
  const navigate = useNavigate();
  const isEdit = mode === "edit";
  return (
    <div className="product-form-page">
      <section className="product-form-hero"><div><p>SecondBite Vendor</p><h2>{isEdit ? "Edit Product" : "Add Product"}</h2><span>Set product details, pickup range, daily quantity, and reset time.</span></div><button type="button" onClick={() => navigate("/vendor/outlet-products")}>Back</button></section>
      <section className="product-form-card">
        <div className="product-form-card__header"><h3>Product Setup</h3><p>Daily sold is read-only and should be calculated from orders.</p></div>
        <div className="product-form-grid">
          <label><span>Product Name</span><input defaultValue={isEdit ? "Chicken Rice Bowl" : ""} placeholder="Enter product name" /></label>
          <label><span>Price (RM)</span><input defaultValue={isEdit ? "18.90" : ""} placeholder="0.00" /></label>
          <label><span>Daily Quantity</span><input defaultValue={isEdit ? "50" : ""} placeholder="0" /></label>
          <label><span>Daily Sold</span><input value={isEdit ? "18" : "0"} readOnly /></label>
          <label><span>Daily Quantity Reset Time</span><input type="time" defaultValue="00:00" /></label>
          <label><span>Status</span><select defaultValue="Active"><option>Active</option><option>Inactive</option><option>Sold Out</option></select></label>
          <label><span>Pickup Start Time</span><input type="time" defaultValue="17:00" /></label>
          <label><span>Pickup End Time</span><input type="time" defaultValue="20:00" /></label>
          <label className="product-form-grid__full"><span>Product Image</span><input type="file" accept="image/*" /></label>
          <label className="product-form-grid__full"><span>Description</span><textarea rows="5" placeholder="Short product description" defaultValue={isEdit ? "Freshly prepared chicken rice bowl for pickup." : ""} /></label>
        </div>
        <div className="product-form-actions"><button type="button" className="product-form-actions__secondary" onClick={() => navigate("/vendor/outlet-products")}>Cancel</button><button type="button" className="product-form-actions__primary" onClick={() => navigate("/vendor/outlet-products")}>{isEdit ? "Save Product" : "Create Product"}</button></div>
      </section>
    </div>
  );
};

export default ProductFormPage;
